import React from 'react'
import './InternationalPhonereloadView.scss'

import CONFIG from '../../../../config'

import {getLanguageScope, C, N, DFS, capitalize, createLazyExecution} from '../../../../helpers'
const _i18n = getLanguageScope('international_phonereload');

import Amount from '../../shared/Amounts/containers/AmountContainer'
import Navigation from '../../shared/Navigation/containers/NavigationContainer'
import InputMask from 'react-input-mask';

import {Grid, Header, Form, Input, Dropdown, Icon, Message} from 'semantic-ui-react'
import {validator} from "../../InternationalPhonereload/models/transaction";

class InternationalPhonereload extends React.Component {
  constructor(props){
    super(props);

    this.lazyUpdateAmounts = createLazyExecution(async function (product, amount) {
      await props.appSetServerVal('product', product);
      await props.appSetServerVal('original_amount', N(amount));
      await props.appCall('updateAmounts')
    }, 555);
  }

  componentDidUpdate(nextProps){
    const {appSetVal, sender_number = ''} = this.props;

    if(nextProps.phone_number && sender_number !== nextProps.phone_number){
      appSetVal('sender_number', nextProps.phone_number);
    }
  }

  updateAmount(product) {
    const {appSetVal, customer_limit_amount, denominations} = this.props;

    const productItem = _.find(denominations, (d) => d.value === product);

    if (customer_limit_amount && N(productItem.amount) > customer_limit_amount) return;

    appSetVal('display_amount', N(productItem.amount));

    this.lazyUpdateAmounts(product, productItem.amount)
  }

  changeRecipientNumber(value){
    const {appSetObj} = this.props;
    appSetObj({
      recipient_number: value,
      recipient_number_error: false
    })
  }

  render(){

    const {ready_to_submit, checkFields, title, icon, denominations, recipient_number, input_mask,
      submitTransaction, recipient_number_error} = this.props;

    return (
      <Grid columns='equal'>
        <Grid.Row divided style={{'minHeight': 250}} stretched columns={2}>

          <Grid.Column>
            <Grid.Row columns={2}>
              <Grid.Column>
                <Header image={`${CONFIG.STATIC_PATH}${icon}`} content={title} as='h3'/>
              </Grid.Column>

              <Grid.Column>

                <Form className='mt-30 mb-30'>

                  <Form.Field required>
                    <label>{_i18n('recipient_phone_number')}</label>
                    <Input iconPosition='left'>
                      <Icon name='phone'/>
                      <InputMask value={recipient_number}
                                 onChange={(e) => this.changeRecipientNumber(DFS(e.currentTarget.value))}
                                 className='without-right-borders' placeholder={_i18n('phone_number')}
                                 mask={input_mask} formatChars={{'ї': '[0-9]'}} maskChar="_"/>

                    </Input>

                    <Message visible={recipient_number_error} error content={_i18n('invalid_recipient_number')}/>

                  </Form.Field>

                  <Form.Field required>
                    <Header as='label' floated='left'>
                      {_i18n('enter_amount')}
                    </Header>

                    <Dropdown
                      search
                      searchInput={{ type: 'number' }}
                      selection
                      onChange={(e, {name, value}) => this.updateAmount(value)}
                      options={denominations}
                      placeholder={_i18n('select_amount')}
                    />

                  </Form.Field>
                </Form>

              </Grid.Column>
            </Grid.Row>
          </Grid.Column>

          <Grid.Column>
            <Grid.Row columns={1}>
              <Grid.Column>
                <Amount hideAmountInput={true} />
              </Grid.Column>
            </Grid.Row>
          </Grid.Column>

        </Grid.Row>

        <Navigation
          onSubmit={submitTransaction}
          showSubmit={true}
          disabledSubmit={ready_to_submit}
          submitValidator={() => checkFields(validator)}
        />

      </Grid>
    )
  }
}

export default InternationalPhonereload


// WEBPACK FOOTER //
// ./src/components/Applications/InternationalPhonereload/components/InternationalPhonereloadView.js